/**
 * Admin session keys in localStorage.
 * Login still stores a UI flag here; the password is verified by POST /api/auth/admin/login.
 */
export const ADMIN_AUTH_KEY = 'admin-authenticated';
export const ADMIN_EMAIL_KEY = 'admin-email';
export const ADMIN_MUST_CHANGE_KEY = 'admin-must-change-password';

export function isAdminAuthenticated(): boolean {
  return localStorage.getItem(ADMIN_AUTH_KEY) === 'true';
}

export function getAdminEmail(): string | null {
  const v = localStorage.getItem(ADMIN_EMAIL_KEY);
  return v && v.trim() ? v.trim() : null;
}

export function mustChangeAdminPassword(): boolean {
  return localStorage.getItem(ADMIN_MUST_CHANGE_KEY) === 'true';
}

export function setAdminSession(email: string, mustChangePassword: boolean): void {
  localStorage.setItem(ADMIN_AUTH_KEY, 'true');
  localStorage.setItem(ADMIN_EMAIL_KEY, email.trim());
  localStorage.setItem(ADMIN_MUST_CHANGE_KEY, mustChangePassword ? 'true' : 'false');
}

export function markAdminPasswordChanged(): void {
  localStorage.setItem(ADMIN_MUST_CHANGE_KEY, 'false');
}

export function clearAdminSession(): void {
  localStorage.removeItem(ADMIN_AUTH_KEY);
  localStorage.removeItem(ADMIN_EMAIL_KEY);
  localStorage.removeItem(ADMIN_MUST_CHANGE_KEY);
}

export function notifyAdminAuthChanged(): void {
  window.dispatchEvent(new Event('admin-auth-change'));
}
